function IconDeparting(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="22"
			height="21"
			viewBox="0 0 22 21"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.897767 20.254C0.897767 19.8397 1.24239 19.504 1.66751 19.504H20.1412C20.5663 19.504 20.911 19.8397 20.911 20.254C20.911 20.6682 20.5663 21.004 20.1412 21.004H1.66751C1.24239 21.004 0.897767 20.6682 0.897767 20.254Z"
				fill="currentColor"
			/>
			<path
				d="M8.03367 0.928216C8.14425 0.924637 8.25498 0.947773 8.35542 0.996735L14.5185 4.00105L16.4537 3.48893L16.4707 3.48476L16.4886 3.48061C17.5585 3.25653 18.8363 3.44419 19.7242 3.93216L20.7742 4.49849L20.7891 4.50674L20.8041 4.51589C22.0868 5.29514 21.8446 7.17912 20.455 7.63757L20.4451 7.64097L20.4344 7.64435L15.7566 9.02249L10.8488 15.0765C10.7569 15.1898 10.6304 15.2714 10.4892 15.308L7.68398 16.036C7.43371 16.1009 7.16827 16.0182 6.99815 15.8235C6.82803 15.6288 6.78218 15.3546 6.88009 15.1153L8.75323 10.5362L4.64987 11.0736C4.43082 11.1022 4.21143 11.0227 4.061 10.8609L0.632922 7.1746C0.467735 6.9967 0.409123 6.74441 0.479408 6.51203C0.549837 6.27944 0.739121 6.10158 0.975528 6.0453L3.40909 5.46588L3.47958 5.45283C3.64436 5.43152 3.81214 5.47135 3.95092 5.56564L5.25879 6.45472L8.60208 5.56935L5.75297 2.42282C5.58775 2.24043 5.53299 1.98336 5.6103 1.74975C5.6878 1.5161 5.88519 1.34164 6.1267 1.29404L7.92405 0.940621L8.03367 0.928216ZM19.0709 5.131C18.4851 4.80733 17.5442 4.65789 16.7785 4.81526L5.30838 7.85563C5.11704 7.90632 4.91328 7.87131 4.74958 7.76003L3.43204 6.86368L2.43093 7.10228L4.82088 9.67277L9.30666 9.08575L9.60719 8.45299L9.67762 8.33674C9.86405 8.08633 10.2041 7.98946 10.5005 8.12008C10.839 8.26944 10.9968 8.66149 10.8567 9.00396L8.65996 14.3702L9.92853 14.0418L14.8308 7.99747L14.9024 7.92216C14.9782 7.85322 15.069 7.80201 15.1682 7.77271L20.0328 6.33808C20.3193 6.23885 20.3685 5.85733 20.1023 5.68812L19.0762 5.13464L19.0709 5.131ZM7.57593 2.40072L10.0888 5.17518L12.4993 4.53667L7.96236 2.32444L7.57593 2.40072Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default IconDeparting;
